module.exports = __webpack_public_path__ + "media/stylesheets/images/Akira Mejima-0c490abb22ef5b5daa6dd25caae5248c.jpg";